module.exports = __webpack_public_path__ + "img/signup-guide-03-03.20abb2a1.png";